module.exports = __webpack_public_path__ + "img/liane1.fc709285.png";